import React, { useEffect } from "react";
import KryzenTop from "../../Quatation/PdfQuotationsTables/kryzen_Top";
import Footer from "../../../Components/Footer/footer";
import SimpleButton from "../../../Components/layouts/simple_button";
import { FcSurvey } from "react-icons/fc";
import { convertRupeesToWords } from "../../../Components/Functions/amt.fun";
import { useState } from "react";
import performRequest from "../../../api/request";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import { useParams } from "react-router";

const OfferLetter = () => {
  const [employeeInfo, setEmployeeInfo] = useState();
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const { id } = useParams();

  function joinWithDash(inputString) {
    var wordsArray = inputString?.split(" ");
    var joinedString = wordsArray?.join("-");
    return joinedString;
  }

  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/employeeManagement/getEmployeeManagementById/${id}`)
      .then((res) => setEmployeeInfo(res.data))
      .catch((err) => CustomErrorResponse(err))
      .finally(() => setLoading(false));
  }, [id, refresh]);

  const printPDF = () => {
    let name = joinWithDash(
      `${employeeInfo?.firstName} ${employeeInfo?.lastName}-Offer-Letter.pdf`
    );
    document.title = name;
    window.print();
  };

  function convertLakhToAmount(lakhValue) {
    if (typeof lakhValue !== "number") {
      throw new Error("Input must be a number");
    }
    const amount = lakhValue * 100000;
    return amount;
  }

  let CTC = convertLakhToAmount(+employeeInfo?.packageJoinedAt);

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xxl">
          <div className="page-header d-print-none">
            <div className="row align-items-center">
              <div className="col-md-8">
                <h2 className="page-title mb-1">
                  <FcSurvey className="fs-2  me-1" /> Preview Offer Letter
                </h2>
              </div>
              <div className="col-md-4">
                <div className="btn-list justify-content-end">
                  <SimpleButton buttonText={"save pdf"} onClick={printPDF} />
                </div>
              </div>
            </div>
          </div>

          <div className="card mt-3">
            <div className="card-body" id="pdf-content">
              <KryzenTop />
              <hr></hr>
              <h3 className="text-center">OFFER LETTER</h3>
              <p
                className="text-end"
                style={{ fontSize: "17px", marginBottom: "0px" }}
              >
                <b>
                  Date.{" "}
                  {new Date(Date.now()).toLocaleDateString("en-GB", {
                    day: "numeric",
                    month: "long",
                    year: "numeric",
                  })}
                </b>
              </p>
              <p style={{ fontSize: "17px" }}>To,</p>
              <p style={{ fontSize: "17px" }}>
                <b>
                  {employeeInfo?.firstName} {employeeInfo?.lastName}
                </b>
              </p>
              <p style={{ fontSize: "17px" }}>{employeeInfo?.city}</p>
              <h3>Subject : Offer of Employment</h3>
              <h3>Dear {employeeInfo?.firstName},</h3>
              <p style={{ fontSize: "17px", marginBottom: "8px" }}>
                Further to the interviews and subsequent discussions held with
                you on a date{" "}
                <b>
                  {employeeInfo?.interviewDate &&
                    new Date(employeeInfo?.interviewDate).toLocaleDateString(
                      "en-GB",
                      {
                        day: "numeric",
                        month: "long",
                        year: "numeric",
                      }
                    )}
                </b>{" "}
                we are pleased to offer you as a {employeeInfo?.position} in our
                organization on the terms discussed with you.
              </p>

              <p style={{ fontSize: "17px", marginBottom: "8px" }}>
                Your annual cost to the company will be INR-{" "}
                <b>{convertLakhToAmount(+employeeInfo?.packageJoinedAt)} /- </b>
                in words <b>{convertRupeesToWords(CTC)} </b>Only.
              </p>
              <p style={{ fontSize: "17px", marginBottom: "8px" }}>
                As a token of your acceptance, please sign a duplicate copy of
                this letter and send it to us for our records.
              </p>
              <p style={{ fontSize: "17px", marginBottom: "8px" }}>
                We look forward to a long and mutually benifical association.
              </p>
              <p style={{ fontSize: "17px", marginBottom: "8px" }}>
                Thanking you,
              </p>
              <p style={{ fontSize: "17px", marginBottom: "8px" }}>
                For <b>Kryzen Biotech Pvt. Ltd.</b>
              </p>
              <br></br>
              <br />
              <br />
              <h3 style={{ marginBottom: "1px" }}>Authorized Signatory</h3>
              <p style={{ fontSize: "17px" }}>
                Accepted. Will tentatively join on{" "}
                <b>
                  {employeeInfo?.dateOfJoining &&
                    new Date(employeeInfo.dateOfJoining).toLocaleDateString(
                      "en-GB",
                      {
                        day: "numeric",
                        month: "long",
                        year: "numeric",
                      }
                    )}
                </b>
              </p>
              <br></br>
              <br></br>
              <br />
              <p style={{ fontSize: "17px" }}>Name & Signature </p>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default OfferLetter;
